import { makeVar } from "@/hooks/useVar.tsx";

export const localPlayerIdVar = makeVar<string | undefined>(undefined);
